import React, { Component } from 'react';
import { Col, Row, Input, Button, Form, Badge } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import CustomSelect from '../../../Base/Common/CustomSelect'
import { StyledCard } from '../../../Base/Common/CommonUIComponents';
import { DateRangePicker } from 'react-dates';
import { CustomTable } from '../../../Base/Common/CustomTable';
import { getAPI } from '../../../Base/API';
import { handleNotification } from '../../../Base/Notification';
import moment from 'moment';
import PciBookingPropertyDetails from './PciBookingPropertyDetails';
import { pciBookingStatus } from '../../../Base/Common/ReferenceDataFunctions';

class PciBookingProperties extends Component {
    constructor(props) {
        super(props);
        this.state = {
            block: false,
            modal: false,
            createdFrom: null,
            createdTo: null
        };
    }

    componentDidMount() {
        this.getProperties();
    }

    getProperties = (e) => {
        if (e) e.preventDefault();

        this.setState({ block: true }, _ => {
            const { createdFrom, createdTo, name, status } = this.state;

            var params = '';
            if (createdFrom) params += `&createdTimeFrom=${moment(createdFrom).format("YYYY-MM-DD")}`
            if (createdTo) params += `&createdTimeTo=${moment(createdTo).format("YYYY-MM-DD")}`;
            if (name) params += `&name=${name}`;
            if (status) params += `&status=${status}`;

            getAPI(result => {
                const { data, error } = result;
                const errorMessage = [];

                if (error) {
                    errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                    this.setState({ error: errorMessage, block: false });
                    return;
                }
                if (data) {
                    if (data.errors && data.errors.length > 0) {
                        handleNotification(data);
                        this.setState(({ block: false, error: errorMessage }));
                        return;
                    }

                    this.setState({ properties: data.response, block: false });
                }
                else {
                    this.setState({ block: false });
                }
            }, `/api/hotel/PCIBooking/v1/property/query?limit=9999` + params);
        })
    }
        
    handleChangeSelect = (name, combo) => {
        this.setState({
            [name]: combo ? combo.value : null
        });
    };

    handlChange = (e) => {
        const { name, value } = e.target;

        this.setState({ [name]: value });
    }

    toggleModal = (selectedPropertyId) => {
        this.setState(prevState => ({
            modal: !prevState.modal,
            selectedPropertyId
        }))
    }

    updateProperties = () => {
        this.getProperties();
        this.toggleModal();
    }

    render() {
        const { block, error, name, status, modal, createdFrom, createdTo } = this.state;

        const columns = [
            {
                dataField: 'userId',
                text: "User Id",
                sort: true
            }, {
                dataField: 'name',
                text: "Name",
                sort: true,
            }, {
                dataField: 'propertyURI',
                text: "Property URI",
                sort: true,
            }, {
                dataField: 'status',
                text: "Status",
                sort: true,
                formatter: (cell) => {
                    const status = pciBookingStatus().find(el => el.value ===  cell);

                    if (status) {
                        return <Badge color={status.color} className="text-white"> {status.label}</Badge>
                    }
                    else {
                        return <Badge className="text-white"> {cell}</Badge>
                    }
                }
            },
        ]

        const selectRow = {
            mode: 'radio',
            hideSelectColumn: true,
            bgColor: '#f8f9fa',
            clickToSelect: true,
            onSelect: (row, isSelect, rowIndex, e) => {
                this.toggleModal(row.userId)
            }
        };

        return (
            <StyledCard block={block} error={error} title="navbar.PciBookingProperties" icon="far fa-building">
                <Form onSubmit={this.getProperties}>
                    <Row className="mb-2 ">
                        <Col className="small">
                            <Input
                                type="text"
                                name="name"
                                value={name}
                                onChange={this.handlChange}
                                placeholder={"Name"}
                            />
                        </Col>
                        <Col className="small">
                            <CustomSelect
                                options={pciBookingStatus()}
                                value={pciBookingStatus().find(opt => opt.value === status)}
                                onChange={(e) => this.handleChangeSelect('status', e)}
                                placeholder={"Status"}
                                isClearable
                            />
                        </Col>
                        <Col className="small">
                            <DateRangePicker
                                startDate={createdFrom ? moment(createdFrom).locale(moment.locale()) : null}
                                startDateId="your_unique_start_date_id_announcement"
                                isOutsideRange={() => false}
                                endDate={createdTo ? moment(createdTo).locale(moment.locale()) : null}
                                endDateId="your_unique_end_date_id_announcement"
                                onDatesChange={({ startDate, endDate }) => this.setState({ createdFrom: startDate, createdTo: endDate })}
                                focusedInput={this.state.focusedInput}
                                onFocusChange={focusedInput => this.setState({ focusedInput })}
                                small={true}
                                numberOfMonths={1}
                                showDefaultInputIcon={true}
                                renderMonthElement={({ month }) => moment(month).locale(this.props.intl.locale).format('MMMM YYYY')}
                            />
                        </Col>
                        <Col className="text-right">
                            <Button className="btn btn-host btn-sm mr-2" onClick={_ => this.toggleModal()}><i className="fas fa-plus"></i></Button>
                            <Button className="btn btn-host btn-sm" type="submit"><i className="fas fa-search"></i></Button>
                        </Col>
                    </Row>
                </Form>
                <hr />
                <CustomTable
                    keyField="userId"
                    data={this.state.properties || []}
                    columns={columns}
                    sizePerPage={10}
                    shadow={false}
                    selectRow={selectRow}
                    search={true}
                    remote={false}
                />

                {modal ?
                    <PciBookingPropertyDetails
                        modal={modal}
                        toggleModal={this.toggleModal}
                        propertyId={this.state.selectedPropertyId}
                        updateProperties={this.updateProperties}
                    />
                : ''}
            </StyledCard>
        );
    }
}

export default injectIntl(PciBookingProperties);